var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @file 添加样式的按钮
 */
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '../Button';
export const ButtonAdd = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(Button, Object.assign({ type: "link", icon: faPlus, fontWeight: "bold", loading: false }, props, { children: children }), void 0));
};
// @ts-expect-error 令其他 antd 组件可以识别该按钮为 antButton，比如 tooltip，相关 issue：https://github.com/ant-design/ant-design/issues/18137
ButtonAdd.__ANT_BUTTON = true;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvQnV0dG9uQWRkL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQTs7R0FFRztBQUNILE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxvQ0FBb0MsQ0FBQTtBQUczRCxPQUFPLEVBQUUsTUFBTSxFQUFlLE1BQU0sV0FBVyxDQUFBO0FBRS9DLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBb0IsQ0FBQyxFQUFzQixFQUFFLEVBQUU7UUFBMUIsRUFBRSxRQUFRLE9BQVksRUFBUCxLQUFLLGNBQXBCLFlBQXNCLENBQUY7SUFBTyxPQUFBLENBQ3BFLEtBQUMsTUFBTSxrQkFDTCxJQUFJLEVBQUMsTUFBTSxFQUNYLElBQUksRUFBRSxNQUFNLEVBQ1osVUFBVSxFQUFDLE1BQU0sRUFDakIsT0FBTyxFQUFFLEtBQUssSUFDVixLQUFLLGNBRVIsUUFBUSxZQUNGLENBQ1YsQ0FBQTtDQUFBLENBQUE7QUFFRCwySEFBMkg7QUFDM0gsU0FBUyxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUEifQ==